import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';

function useDeleteSubject() {
  const queryClient = useQueryClient();
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  function deleteSubject(subjectID) {
    return privateFetch.delete(`/v1/admin/subject/${subjectID}`);
  }

  return useMutation(deleteSubject, {
    onSuccess() {},
    onSettled() {
      queryClient.invalidateQueries('subjects');
    },
  });
}

export default useDeleteSubject;
